module.exports = __webpack_public_path__ + "static/media/clue-1.f016d97f.svg";